<template>
  <div class="animated fadeIn dashboard-root row">
    <div class="dashboard-panel col-lg-12 col-xl-12">
      <div>
        <div v-if="data && data.length > 1" class="applications-row">
          <div
            v-for="(application, applicationsGroupIndex) in data"
            :key="applicationsGroupIndex"
            class="application-item"
            :class="{ selected: application['id'] == selectedApplication }"
          >
            <div class="application-card" @click="selectApplication(application['id'])">
              <div>
                <img :src="application['image']" />
                <span>{{ uniTranslation(application["name"]) }}</span>
              </div>
            </div>
            <div
              v-if="selectedApplication == application['id']"
              v-on-clickaway="clickOutside"
              class="modalities-row"
            >
              <div
                v-for="(modality, modalityIndex) in application['modalities']"
                :key="modalityIndex"
                class="modality-item"
              >
                <div
                  class="modality-card"
                  :class="'modality_' + modality['id']"
                  @click="goToModality(modality.id)"
                >
                  <div class="modality-logo-placeholder"></div>
                  <span>{{ uniTranslation(modality["name"]) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="data && data[0]">
          <div class="applications-row ">
            <div
              v-for="(modality, modalityIndex) in data[0]['modalities']"
              :key="modalityIndex"
              class="application-item"
            >
              <img
                :src="modality['image']"
                width="200"
                height="200"
                style="cursor: pointer"
                @click="goToModality(modality.id)"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- <container></container> -->
    </div>
  </div>
</template>

<script>
// import { api } from "../gateways/unilabApi";
// import Container from "../components/unidata/ContainerExample.vue";
// import store from "../store";
import { mapGetters } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import dashboardService from "../services/backend/dashboardService";
import generalService from "../services/backendCipriani/generalService";
import umService from "../services/backend/umService";

export default {
  name: "Dashboard",
  mixins: [clickaway],
  data() {
    return {
      data: [],
      visualizationData: [],
      selectedApplication: -1,
      compName: "Dashboard",
      loading: false
    };
  },
  computed: {
    ...mapGetters(["projects", "currentLanguage", "projectsWindows"])
  },
  mounted: function() {
    document.getElementById("mainOverlay").setAttribute("style", "display: none;");

    document.getElementById("mainRouterView").setAttribute("style", "");

    var that = this;
    generalService.getApps().then(function(data) {
      that.data = data;
    });

    generalService.getFluidsDividedByTipo().then(data => {
      var dict = {};
      data.forEach(el => {
        dict[el.type + ""] = el.list;
      });

      that.$store.dispatch("loadFluidsDictionary", dict);
    });

    umService.getUmsDictionary().then(data => {
      that.$store.dispatch("loadUmsDictionary", data);
    });

    var local = document.getElementById("CiprianiPath").value;
    const favicon = document.getElementById("favicon");
    generalService.getFavicon(local).then(function(data) {
      favicon.href = data + "favicon.ico";
    });

    //==========================================
    //MARCO DC 20/07/2021
    //Aggiunto su loro richiesta per mettere i titoli dei tab personalizzati
    that.impostaTitolo();
    document.getElementById("currentComponent").value = this.compName;

    that.$store.subscribe(function(mutation /*, state*/) {
      var comp = document.getElementById("currentComponent").value;
      if (mutation.type === "changeLanguage" && comp == that.compName) {
        that.impostaTitolo();
      }
    });
    //==========================================
    /*generalService.getTitle(local).then(function(data) {
     title.innerHTML = data;
    });*/
  },
  methods: {
    impostaTitolo: function() {
      const title = document.getElementById("title");
      title.innerHTML = this.$t("PHETITLEHOME");
    },
    goToModality: function(modality) {
      if (!this.loading) {
        this.loading = true;
        this.$router.push({
          name: "CreateProject",
          params: {
            modality: modality
          }
        });
      }
    },

    clickOutside: function() {
      this.selectedApplication = -1;
    },
    rielaborateData: function(data) {
      var colNumber = 4;
      var visualizationData = [];
      var visualizationDataItem = null;

      data.forEach(function(val, index) {
        if (index % colNumber == 0) {
          // Controllo se ho qualcosa nell'item prima di resettarlo (per il caso del primo ciclo con index pari a 0)
          if (visualizationDataItem && visualizationDataItem["applications"].length != 0) {
            visualizationData.push(visualizationDataItem);
          }
          visualizationDataItem = { applications: [], modalities: [] };
        }

        visualizationDataItem["applications"].push({
          name: val["name"],
          id: val["id"],
          image: val["image"]
        });

        visualizationDataItem["modalities"].push({
          applicationId: val["id"],
          modality: val["modality"]
        });
      });

      // Controllo se all'interno dell'item ho qualcosa e in caso lo aggiungo
      if (visualizationDataItem["applications"].length != 0) {
        visualizationData.push(visualizationDataItem);
      }
      console.log(visualizationData);
      return visualizationData;
    },
    selectApplication: function(applicationId) {
      this.$nextTick(function() {
        if (this.selectedApplication == applicationId) {
          this.selectedApplication = null;
        } else {
          this.selectedApplication = applicationId;
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/custom";

$application-box-width: 300px;
$application-box-height: 100%;

$application-image-size: 80px;
$modality-logo-size: 40px;

$selected-opacity: 0.5;

.modality-logo-placeholder {
  border-radius: 3px;
  width: $modality-logo-size;
  height: $modality-logo-size;
}

.modality_1 {
  .modality-logo-placeholder {
    background-color: red;
  }
}

.modality_2 {
  .modality-logo-placeholder {
    background-color: blue;
  }
}

.modality_3 {
  .modality-logo-placeholder {
    background-color: #ab5aa7;
  }
}

.modality_4 {
  .modality-logo-placeholder {
    background-color: #5aab8c;
  }
}

.modality_5 {
  .modality-logo-placeholder {
    background-color: gold;
  }
}

.modality_6 {
  .modality-logo-placeholder {
    background-color: green;
  }
}

.modality_7 {
  .modality-logo-placeholder {
    background-color: yellow;
  }
}

.modality_8 {
  .modality-logo-placeholder {
    background-color: red;
  }
}

.modality_9 {
  .modality-logo-placeholder {
    background-color: blue;
  }
}

.modality_10 {
  .modality-logo-placeholder {
    background-color: #ab5aa7;
  }
}

.modality_11 {
  .modality-logo-placeholder {
    background-color: #5aab8c;
  }
}

.applications-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .application-item {
    position: relative;
    width: $application-box-width;
    height: $application-box-height;
    display: flex;
    justify-content: center;
    align-items: center;

    .application-card {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      margin: 5px;
      padding: 20px;
      border-radius: 6px;

      background-color: $unilab-secondary;
      cursor: pointer;

      img {
        border-radius: 4px;
        width: $application-image-size;
        height: $application-image-size;
      }

      span {
        margin-left: 10px;
        font-size: 1.2em;
        // text-transform: uppercase;
      }
    }

    &.selected {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      background-color: $selection-active-opacity;
    }
  }

  .modalities-row {
    width: auto;
    position: absolute;
    top: $application-box-height;
    z-index: 100;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 5px;

    background-color: $selection-active-opacity;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    .modality-item {
      width: 100%;

      .modality-card {
        display: flex;
        align-items: center;

        margin: 5px 10px;
        background-color: aliceblue;
        padding: 10px;
        border-radius: 6px;

        cursor: pointer;

        span {
          padding-left: 10px;
        }

        .modality-logo-placeholder {
          border-radius: 3px;
          width: $modality-logo-size;
          height: $modality-logo-size;
        }
      }
    }
  }
}

/*.news-panel {

}*/
</style>
